import { Visibility } from "authory-api-types/dist/enums";
import { ArticlePreviewResponse, Collection, UserResponse } from "authory-api-types/dist/types";
import { EmbedTheme } from "../../utils/embeds";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3EmbedAuthor, EmbedWrapper } from "../V3EmbedContent";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3EmbedCollectionTitle, V3EmbedCollBody, V3EmbedCollectionDesc, V3EmbedCollectionSeparator } from "./V3EmbedCollection.styles";
import { V3EmbedContentListItem } from "./V3EmbedContentListitem";
import { V3EmbedCTA } from "./V3EmbedCTA";

interface V3EmbedCollectionProps {
    embedTheme?: EmbedTheme;
    author: UserResponse;
    showHeader?: boolean;
    collection?: Collection;
    items: ArticlePreviewResponse[];
}

export const V3EmbedCollection = ({ embedTheme = EmbedTheme.light, author, collection, showHeader = true, items }: V3EmbedCollectionProps) => {
    const hasDescription = !!collection?.description;

    const colTarget = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${author.slug}/collection/${collection?.slug}`;

    return (
        <EmbedWrapper embedTheme={embedTheme}>
            {showHeader && (
                <>
                    <V3EmbedAuthor author={author} embedTheme={embedTheme} />
                    <VerticalSpacing bottom={6}>
                        <UnstyledLink href={colTarget} target="_blank">
                            <V3EmbedCollBody $embedTheme={embedTheme} $numLines={1}>
                                <strong>{`${collection?.articleCount} content items from ${collection?.publicationCount} sources`}</strong>
                            </V3EmbedCollBody>
                        </UnstyledLink>
                    </VerticalSpacing>
                    <VerticalSpacing bottom={hasDescription ? 6 : 16}>
                        <UnstyledLink href={colTarget} target="_blank">
                            <V3EmbedCollectionTitle $embedTheme={embedTheme} $numLines={1}>
                                {collection?.label}
                            </V3EmbedCollectionTitle>
                        </UnstyledLink>
                    </VerticalSpacing>
                    {hasDescription && (
                        <VerticalSpacing bottom={16}>
                            <V3EmbedCollectionDesc $embedTheme={embedTheme} $numLines={1}>
                                {collection.description}
                            </V3EmbedCollectionDesc>
                        </VerticalSpacing>
                    )}
                    <VerticalSpacing bottom={16}>
                        <V3EmbedCollectionSeparator />
                    </VerticalSpacing>
                </>
            )}
            {items.map((item, index) => (
                <VerticalSpacing bottom={index === items.length - 1 ? 20 : 16} key={index}>
                    <V3EmbedContentListItem
                        item={item}
                        embedTheme={embedTheme}
                        itemsHref={`/${author.slug}`}
                        collectionSlug={collection?.overrideContentVisibility === Visibility.Public ? collection?.slug : undefined}
                    />
                </VerticalSpacing>
            ))}
            <V3EmbedCTA target={colTarget} label="View entire collection" embedTheme={embedTheme} utmCampaign="collection" />
        </EmbedWrapper>
    );
};
